// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar_avatar__qbz0B {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-full);
  overflow: hidden;
  flex-shrink: 0;
}
.Avatar_avatar__qbz0B.Avatar_noImage__4XiGV {
  background-color: var(--color-surface-light);
  border: 1px solid var(--color-border);
  color: var(--color-text);
}

.Avatar_image__txssE {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Avatar_initials__eEAlY {
  font-weight: 500;
  line-height: 1;
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Avatar_size_xsmall__vaS0z {
  width: 20px;
  height: 20px;
  font-size: 10px;
}

.Avatar_size_small__rKhxY {
  width: 24px;
  height: 24px;
  font-size: 12px;
}

.Avatar_size_medium__OjYNY {
  width: 28px;
  height: 28px;
  font-size: 14px;
}

.Avatar_size_large__AM\\+K5 {
  width: 36px;
  height: 36px;
  font-size: 16px;
}

.Avatar_size_xlarge__CYQ88 {
  width: 48px;
  height: 48px;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Avatar/Avatar.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,gBAAA;EACA,cAAA;AACF;AACE;EACE,4CAAA;EACA,qCAAA;EACA,wBAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF","sourcesContent":[".avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-full);\n  overflow: hidden;\n  flex-shrink: 0;\n  \n  &.noImage {\n    background-color: var(--color-surface-light);\n    border: 1px solid var(--color-border);\n    color: var(--color-text);\n  }\n}\n\n.image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.initials {\n  font-weight: 500;\n  line-height: 1;\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n// Size variants based on existing usage in the app\n.size_xsmall {\n  width: 20px;\n  height: 20px;\n  font-size: 10px;\n}\n\n.size_small {\n  width: 24px;\n  height: 24px;\n  font-size: 12px;\n}\n\n.size_medium {\n  width: 28px;\n  height: 28px;\n  font-size: 14px;\n}\n\n.size_large {\n  width: 36px;\n  height: 36px;\n  font-size: 16px;\n}\n\n.size_xlarge {\n  width: 48px;\n  height: 48px;\n  font-size: 20px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `Avatar_avatar__qbz0B`,
	"noImage": `Avatar_noImage__4XiGV`,
	"image": `Avatar_image__txssE`,
	"initials": `Avatar_initials__eEAlY`,
	"size_xsmall": `Avatar_size_xsmall__vaS0z`,
	"size_small": `Avatar_size_small__rKhxY`,
	"size_medium": `Avatar_size_medium__OjYNY`,
	"size_large": `Avatar_size_large__AM+K5`,
	"size_xlarge": `Avatar_size_xlarge__CYQ88`
};
export default ___CSS_LOADER_EXPORT___;
